import OrderResetPage from "./OrderResetPage.vue";

export {OrderResetPage}
export default OrderResetPage
